'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _btoa = require('btoa');

var _btoa2 = _interopRequireDefault(_btoa);

var _client = require('./client');

var _client2 = _interopRequireDefault(_client);

var _authorization = require('./api/authorization');

var _authorization2 = _interopRequireDefault(_authorization);

var _calendarEvents = require('./api/calendarEvents');

var _calendarEvents2 = _interopRequireDefault(_calendarEvents);

var _certifications = require('./api/certifications');

var _certifications2 = _interopRequireDefault(_certifications);

var _cloud9Urls = require('./api/cloud9Urls');

var _cloud9Urls2 = _interopRequireDefault(_cloud9Urls);

var _customerListFileUpload = require('./api/customerListFileUpload');

var _customerListFileUpload2 = _interopRequireDefault(_customerListFileUpload);

var _customers = require('./api/customers');

var _customers2 = _interopRequireDefault(_customers);

var _customerStatistics = require('./api/customerStatistics');

var _customerStatistics2 = _interopRequireDefault(_customerStatistics);

var _dashboardModule = require('./api/dashboardModule');

var _dashboardModule2 = _interopRequireDefault(_dashboardModule);

var _dataItems = require('./api/dataItems');

var _dataItems2 = _interopRequireDefault(_dataItems);

var _dataTypeAttachment = require('./api/dataTypeAttachment');

var _dataTypeAttachment2 = _interopRequireDefault(_dataTypeAttachment);

var _dataTypes = require('./api/dataTypes');

var _dataTypes2 = _interopRequireDefault(_dataTypes);

var _doubleOptin = require('./api/doubleOptin');

var _doubleOptin2 = _interopRequireDefault(_doubleOptin);

var _fileJob = require('./api/fileJob');

var _fileJob2 = _interopRequireDefault(_fileJob);

var _groups = require('./api/groups');

var _groups2 = _interopRequireDefault(_groups);

var _groupSearch = require('./api/groupSearch');

var _groupSearch2 = _interopRequireDefault(_groupSearch);

var _locationLists = require('./api/locationLists');

var _locationLists2 = _interopRequireDefault(_locationLists);

var _locations = require('./api/locations');

var _locations2 = _interopRequireDefault(_locations);

var _organizationMetadata = require('./api/organizationMetadata');

var _organizationMetadata2 = _interopRequireDefault(_organizationMetadata);

var _organizations = require('./api/organizations');

var _organizations2 = _interopRequireDefault(_organizations);

var _organizationSearch = require('./api/organizationSearch');

var _organizationSearch2 = _interopRequireDefault(_organizationSearch);

var _payments = require('./api/payments');

var _payments2 = _interopRequireDefault(_payments);

var _pushNotifications = require('./api/pushNotifications');

var _pushNotifications2 = _interopRequireDefault(_pushNotifications);

var _reports = require('./api/reports');

var _reports2 = _interopRequireDefault(_reports);

var _requestProjectReview = require('./api/requestProjectReview');

var _requestProjectReview2 = _interopRequireDefault(_requestProjectReview);

var _search = require('./api/search');

var _search2 = _interopRequireDefault(_search);

var _signup = require('./api/signup');

var _signup2 = _interopRequireDefault(_signup);

var _subscriptions = require('./api/subscriptions');

var _subscriptions2 = _interopRequireDefault(_subscriptions);

var _targetLists = require('./api/targetLists');

var _targetLists2 = _interopRequireDefault(_targetLists);

var _targets = require('./api/targets');

var _targets2 = _interopRequireDefault(_targets);

var _templates = require('./api/templates');

var _templates2 = _interopRequireDefault(_templates);

var _ticketEvents = require('./api/ticketEvents');

var _ticketEvents2 = _interopRequireDefault(_ticketEvents);

var _ticketMetadata = require('./api/ticketMetadata');

var _ticketMetadata2 = _interopRequireDefault(_ticketMetadata);

var _tickets = require('./api/tickets');

var _tickets2 = _interopRequireDefault(_tickets);

var _versions = require('./api/versions');

var _versions2 = _interopRequireDefault(_versions);

var _waves = require('./api/waves');

var _waves2 = _interopRequireDefault(_waves);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GigwalkAPI = function () {

    // The http client
    function GigwalkAPI() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, GigwalkAPI);

        var client = new _client2.default({ baseURL: 'https://' + (config.hostname || 'api.app.gigwalk.com') });
        this.client = client;

        // AxiosIssue - global.defaults and client.defaults reference the same object. Changing the instance
        // defaults will affect the global namespace (and therefore any other axios instances)
        // See https://github.com/mzabriskie/axios/issues/391
        client.defaults = (0, _lodash2.default)(client.defaults);

        this.authorization = new _authorization2.default(client);
        this.calendarEvents = new _calendarEvents2.default(client);
        this.certifications = new _certifications2.default(client);
        this.cloud9Urls = new _cloud9Urls2.default(client);
        this.customerListFileUpload = new _customerListFileUpload2.default(client);
        this.customers = new _customers2.default(client);
        this.customerStatistics = new _customerStatistics2.default(client);
        this.dashboardModule = new _dashboardModule2.default(client);
        this.dataItems = new _dataItems2.default(client);
        this.dataTypeAttachment = new _dataTypeAttachment2.default(client);
        this.dataTypes = new _dataTypes2.default(client);
        this.doubleOptin = new _doubleOptin2.default(client);
        this.fileJob = new _fileJob2.default(client);
        this.groups = new _groups2.default(client);
        this.groupSearch = new _groupSearch2.default(client);
        this.locationLists = new _locationLists2.default(client);
        this.locations = new _locations2.default(client);
        this.organizationMetadata = new _organizationMetadata2.default(client);
        this.organizations = new _organizations2.default(client);
        this.organizationSearch = new _organizationSearch2.default(client);
        this.payments = new _payments2.default(client);
        this.pushNotifications = new _pushNotifications2.default(client);
        this.reports = new _reports2.default(client);
        this.requestProjectReview = new _requestProjectReview2.default(client);
        this.search = new _search2.default(client);
        this.signup = new _signup2.default(client);
        this.subscriptions = new _subscriptions2.default(client);
        this.targetLists = new _targetLists2.default(client);
        this.targets = new _targets2.default(client);
        this.templates = new _templates2.default(client);
        this.ticketEvents = new _ticketEvents2.default(client);
        this.ticketMetadata = new _ticketMetadata2.default(client);
        this.tickets = new _tickets2.default(client);
        this.versions = new _versions2.default(client);
        this.waves = new _waves2.default(client);
    }

    // API resources


    (0, _createClass3.default)(GigwalkAPI, [{
        key: 'authenticate',
        value: function authenticate(auth) {
            var header = '';
            if (typeof auth.username === 'string' && typeof auth.password === 'string') {
                header = 'Basic ' + (0, _btoa2.default)(auth.username + ':' + auth.password);
            } else if (typeof auth.token === 'string') {
                header = 'Token ' + auth.token;
            }

            (0, _assign2.default)(this.client.defaults, {
                headers: {
                    common: (0, _extends3.default)({}, this.client.defaults.hasOwnProperty('headers') && this.client.defaults.headers.hasOwnProperty('common') ? this.client.defaults.headers.common : {}, {
                        Authorization: header
                    })
                }
            });
        }
    }]);
    return GigwalkAPI;
}();

exports.default = GigwalkAPI;
//# sourceMappingURL=index.js.map